'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Typeahead = require('../../../src/frontend/helper/search/view/m_typeahead.coffee');

var _require = require('../../../src/frontend/helper/search/helper/m_searchbar_helper.coffee'),
    saveLocationAndRedirect = _require.saveLocationAndRedirect;

var helper = require('./myplaces_helper');

var truncateClass = 'should-truncate-singleline';
var activeClass = 'active';
var formErrorClass = 'form-error';

module.exports = function () {
  function MyPlacesModal() {
    _classCallCheck(this, MyPlacesModal);

    this.$location = $('#my-places-address');
    this.$clearInput = $('#my-places-clear');
    this.$placesSearch = $('#places-search');
    this.$gigField = $('#places-search .gig-field');
    this.$typePills = $('.pills2 a');
    this.$submit = $('#places-submit');
    this.$resultList = $('#my-places-autocomplete');
    this.$form = $('#places-form');
    this.$errorMessage = $('#my-places-form-error-message');

    this.typeahead = new Typeahead({
      env: 'desktop',
      resultList: this.$resultList,
      endpoints: {
        location: Groupon.endpoints.locations
      },
      options: {
        fetchWithPlacesApi: true,
        enableRecentSearches: false,
        enableRecentLocations: false,
        enableGeoLocation: false,
        enableSearchCategories: false
      }
    });
    this.placeId = null;
    this.address = '';
  }

  _createClass(MyPlacesModal, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.$location.on('input', this.handleInput.bind(this));
      this.$location.on('focus', this.handleFocus.bind(this));
      this.$location.on('blur', this.handleBlur.bind(this));

      this.$clearInput.on('click', this.handleClear.bind(this));
      this.$resultList.on('click', 'a', this.handleResultClick.bind(this));
      this.$typePills.on('click', this.handleTypePillsClick.bind(this));
      this.$form.on('submit', this.handleFormSubmit.bind(this));

      $('body').on('click', this.handleBodyClick.bind(this));
    }

    // open the modal

  }, {
    key: 'open',
    value: function open() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.setPlace(address);
      if (helper.isLoggedIn()) {
        this.$submit.text('Save');
      }
      this.typeahead.hide(); // do not open the typeahead
      this.hideErrorMessage(); // hide error message
    }

    // set the new address value
    // update the input value

  }, {
    key: 'setPlace',
    value: function setPlace() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var placeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.address = address;
      this.placeId = placeId;
      if (address) {
        this.$gigField.addClass('filled');
        this.$location.val(address);
      } else {
        this.$gigField.removeClass('filled');
        this.$location.val('').focus();
      }
    }
  }, {
    key: 'setFilledClass',
    value: function setFilledClass() {
      if (this.$location.val().length) {
        this.$placesSearch.addClass('filled');
      } else {
        this.$placesSearch.removeClass('filled');
      }
    }

    // select place from autocomplete list

  }, {
    key: 'selectPlace',
    value: function selectPlace(placeItemElement) {
      var address = $(placeItemElement).data('value');
      var placeId = $(placeItemElement).data('place_id');
      if (address && placeId) {
        this.setPlace(address, placeId);
        this.typeahead.hide(); // hide the autocomplete
      }
    }

    // handle the event when the user starts to input
    // build and display the autocomplete list

  }, {
    key: 'handleInput',
    value: function handleInput(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.hideErrorMessage();
      this.typeahead.buildAutocompleteListThrottle(e, 'location');
      this.setFilledClass();
    }

    // when the input gets focus

  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.$placesSearch.addClass('focused');
      this.$location.removeClass(truncateClass);
      this.setFilledClass();
    }

    // when the input losses focus

  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.$placesSearch.removeClass('focused');
      this.$location.addClass(truncateClass);
      this.setFilledClass();
    }

    // click the clear button

  }, {
    key: 'handleClear',
    value: function handleClear() {
      this.setPlace();
    }

    // click on the item from auto complete list

  }, {
    key: 'handleResultClick',
    value: function handleResultClick(e) {
      this.selectPlace(e.currentTarget);
      e.preventDefault();
    }

    // hide the typeahead when it clicks on the page

  }, {
    key: 'handleBodyClick',
    value: function handleBodyClick() {
      this.typeahead.hide();
    }
  }, {
    key: 'handleTypePillsClick',
    value: function handleTypePillsClick(e) {
      $(e.currentTarget).addClass(activeClass).siblings().removeClass(activeClass);
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      if (!this.verifyInput()) {
        return;
      }

      this.savePlace();
    }

    // save as current location in search bar
    // and redirect to the address

  }, {
    key: 'saveAndRedirect',
    value: function saveAndRedirect(placeId, callback) {
      if (!placeId) {
        // this is from Prompt
        window.location.href = window.location.href; // refresh current page
        return;
      }
      $.ajax({
        url: [Groupon.endpoints.places_details, 'v1'].join('/'),
        data: { place_id: placeId },
        headers: { 'x-ls-client-req': true, 'x-ls-locale': I18n.locale },
        success: function success(_ref) {
          var data = _ref.data,
              err = _ref.err;

          if (err) {
            callback(err);
            return;
          }
          var locationData = Object.assign(data, {
            locationId: placeId,
            division: data.closestDivision
          });
          callback(null, locationData);
        },
        error: function error(err) {
          return callback(err);
        }
      });
    }
  }, {
    key: 'failedToSave',
    value: function failedToSave() /* err */{
      this.$submit.removeAttr('disabled');
      this.$submit.removeClass('loading');
      this.showErrorMessage('Failed to save address');
    }

    // save the place

  }, {
    key: 'savePlace',
    value: function savePlace() {
      var _this = this;

      var type = this.$typePills.filter('.active').data('type');
      var icon = helper.getIcon(type);
      var address = this.address;
      var placeId = this.placeId;
      var place = { type: type, icon: icon, address: address, placeId: placeId };

      this.$submit.attr('disabled', 'disabled');
      this.$submit.addClass('loading');

      helper.savePlace(place, {
        success: function success() {
          _this.saveAndRedirect(placeId, function (err, locationData) {
            if (err) {
              _this.failedToSave(err);
            } else {
              saveLocationAndRedirect(locationData);
            }
          });
        },
        error: function error(err) {
          _this.failedToSave(err);
        }
      });
    }

    // hide the error message

  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      if (!this.$placesSearch.hasClass(formErrorClass)) {
        return;
      }
      this.$placesSearch.removeClass(formErrorClass);
      this.$errorMessage.addClass('ls-hide').text('');
    }
  }, {
    key: 'showErrorMessage',
    value: function showErrorMessage(msg) {
      this.$placesSearch.addClass(formErrorClass);
      this.$errorMessage.removeClass('ls-hide').text(msg);
    }
  }, {
    key: 'verifyInput',
    value: function verifyInput() {
      if (!this.address) {
        this.showErrorMessage('Invalid Address'); // @TODO: Translation
        return false;
      }
      return true;
    }
  }]);

  return MyPlacesModal;
}();